export function relativeChange(a, b){
  const change = Math.abs(a - b) / Math.max(Math.abs(a), Math.abs(b)) * 100;
  return a > b ? change * -1 : change;
}